import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SalesPage } from '@/features/sales/pages/SalesPage'

const searchSchema = z.object({
  tab: z.enum(['sales', 'shifts', 'staff']).catch('sales'),
})

export const Route = createFileRoute('/_app/sales/')({
  validateSearch: searchSchema,
  component: SalesPage,
})
